import React, { useContext, useState } from "react";
import { OCLandInsightsContext } from "../../../../hooks/context/OcLandInsightsContext";
import { omInspectionGisFieldsObject } from "../FieldObjects";
import Graphic from "@arcgis/core/Graphic";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { removeFromSelectionHandler, selectDataHandler } from "../../select-form/spatial-select/spatialSelectVM";
const RejectPackageBtn = ({ payload, view,disabled }) => {
  const{ objectId, packageId,status } = omInspectionGisFieldsObject;
  const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);
  const { channelInspections, roadInspections } =
    ocLandInsightsDictionaryCtx.data || {};

  const [loading, setLoading] = useState(false); // State to track loading status
  const [dialogOpen, setDialogOpen] = useState(false); // State to track dialog open status
  const [dialogMessage, setDialogMessage] = useState(""); // State to track dialog message
  const [error, setError] = useState(null); // State to track any errors
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const onClick = async () => {
    let layerId: string | undefined = undefined;
    let objectIds: any[] = [];
    let targetPackageId: any | undefined;

    setLoading(true); // Start loading indicator
    setError(null); // Reset any previous error
    if (!payload.length) {
      setLoading(false);
      setError("No payload data available.");
      return;
    }
    if (payload.length > 1) {
      setLoading(false);
      setError("Please only Select One Layer to Reject.");
      return;
    }
    layerId = payload[0].layerId;
    targetPackageId = payload[0].features[0].attributes[packageId.name];

    for (let i = 0; i < payload[0].features.length; i++) {
      const feature = payload[0].features[i];
      if (
        feature.parentCustomParameters?.OCLandInsightsID !==
          channelInspections &&
        feature.parentCustomParameters?.OCLandInsightsID !== roadInspections
      ) {
        setLoading(false);
        setError("Please select a layer for Channel or Road Inspections.");
        return; //left off here
      }
      if (feature.attributes[packageId.name] !== targetPackageId) {
        setLoading(false);
        setError("You are only allowed to reject one work package at a time.");
        return;
      }


      objectIds.push(feature.attributes[objectId.name]);
    }
    if (objectIds.length < 1) {
      setLoading(false);
      setError("No valid features selected to reject a package.");
      return;
    }
    try {
      // Simulate API call or processing
      let featLayer = view.map.allLayers.find((layer) => layer.id === layerId);
     if (!featLayer) {
        throw new Error("Layer not found.");
      }

      let graphicsArray: Graphic[] = [];
      for (let o = 0; o < objectIds.length; o++) {
        graphicsArray.push(
          new Graphic({
            attributes: {
              [objectId.name]: objectIds[o],
              [status.name]: "Return to Inspector",
              [packageId.name]: "",
            },
          })
        );
      }

      let editedFeatures = await featLayer.applyEdits({
        updateFeatures: graphicsArray,
      });
      if(editedFeatures?.updateFeatureResults.length >0) {
        
      const updatedObjectIds = editedFeatures.updateFeatureResults
        .map((result: { objectId?: number }) => result.objectId)
        .filter((id: number | undefined): id is number => id !== undefined);

      if (updatedObjectIds.length > 0) {
                await removeFromSelectionHandler(view, {
          layerId: featLayer.id,
          queryString: `${objectId.name} IN (${updatedObjectIds.join(",")})`,
        });
        await selectDataHandler(
          view,
          {
        layerId: featLayer.id,
        queryString: `${objectId.name} IN (${updatedObjectIds.join(",")})`,
          },
          false
        );
      }
      }


      // Handle successful operation
      setDialogMessage("Package removed successfully!");
      setDialogOpen(true);
      console.log("Package removed successfully:", editedFeatures);
      return editedFeatures;
    } catch (err: Error | any) {
      // Handle error
      if (err instanceof Error) {
        setError(`Failed to remove package. Error: ${err.message}`);
      } else {
        setError("Failed to remove package. An unknown error occurred.");
      }
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };

  return (
    <>
      <Dialog
        open={!!error}
        onClose={() => {
          setError(null);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title" sx={{ color: "error.main" }}>
          Error
        </DialogTitle>
        <DialogContent>
          <Typography id="error-dialog-description">{error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setError(null);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title" sx={{ color: "warning.main" }}>
          Warning
        </DialogTitle>
        <DialogContent>
          <Typography id="error-dialog-description">
            You are about to remove a Package do you wish to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmDialogOpen(false);
              onClick();
            }}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        aria-labelledby="success-dialog-title"
      >
        <DialogTitle id="success-dialog-title">Success</DialogTitle>
        <DialogContent>
          <Typography>{dialogMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogOpen(false)}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {loading && (
        <Backdrop sx={{ zIndex: 2000 }} open={true}>
          <CircularProgress size={120} thickness={4} />
        </Backdrop>
      )}
      <Button
        onClick={() => {
          setConfirmDialogOpen(true);
        }}
        size="small"
        disabled={loading || disabled}
        sx={{
          fontSize: 10,
          height: "40px",
          color: "#424242", // dark grey
          borderColor: "error.main",
          backgroundColor: "error.light",
          "&:hover": {
        backgroundColor: "error.dark",
        color: "#fff",
        borderColor: "error.dark",
          },
        }}
        variant="outlined"
      >
        Remove package
      </Button>
    </>
  );
};

export default RejectPackageBtn;
